import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { updateVerificationMutation, createCommentMutation, createEOneFromVerficationMutation } from './api';
import { CommentsTimeline } from './CommentsTimeline';
import StatusDropdown from './StatusDropdown';
import VerificationStatuses from './VerificationStatuses';
import moment from 'moment';
import AdditionalTransferFields from './AddtionalTransferFields';
import { Snackbar } from '../../components/Snackbar';

const EditVerificationForm = (props: any) => {
  const [comment, setComment] = React.useState('');
  const [updateVerification] = useMutation(updateVerificationMutation);
  const [createComment] = useMutation(createCommentMutation);
  const [createEOneUpdate] = useMutation(createEOneFromVerficationMutation);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  const [visible, setVisible] = React.useState(false);
  const [createVisible, setCreateVisible] = React.useState(props.created);

  const formatDate = (unformattedDate: any) => {
    let date = new Date(unformattedDate);

    try {
      return moment(date).format('MMMM Do YYYY, h:mm a');
    } catch (error) {
      return 'Invalid Date';
    }
  };

  const initialFormikValues = {
    id: props.queryData.verificationById.VerifyId,
    status: props.queryData.verificationById.Status,
    barCode: props.queryData.verificationById.BarCodeNumber,
    userId: user.adId,
    userDepartment: props.queryData.verificationById.userDepartment.Name,
    itemDepartment: props.queryData.verificationById.itemDepartment ? props.queryData.verificationById.itemDepartment.Name : '',
    InventoryYear: new Date().getFullYear(),
    type: props.queryData.verificationById.Type,
    latitude: props.queryData.verificationById.latitude,
    longitude: props.queryData.verificationById.longitude,
    verifyDate: formatDate(props.queryData.verificationById.VerifyDate),
    AssetNumber: props.queryData.verificationById.AssetNumber,
    physicalOwner: props.queryData.verificationById.PhysicalOwner,
    transferTo: props.queryData.verificationById.transferTo,
    businessUnit: '',
    equipmentStatus: null,
  };

  const createCommentForVerification = async (verifyId: number) => {
    const commentObject = {
      verifyId: verifyId,
      barcode: props.data.verificationById.BarCodeNumber,
      createdBy: user.adId,
      lastUpdatedBy: user.adId,
      comment: comment,
      updatedOn: new Date(),
      entryType: 'inventorycomment',
      requestId: null,
    };

    try {
      await createComment({ variables: commentObject });
      setVisible(true);
    } catch (err) {
      console.log('Error: /frontend/src/components/VerificationForms/EditVerificationForm//createCommentForVerification', err);
    }
  };

  const formik = useFormik({
    initialValues: initialFormikValues,

    onSubmit: async (values: any, e: any) => {
      let error = '';
      // Needs ths to avoid error from date formatting
      values.verifyDate = new Date(props.queryData.verificationById.VerifyDate);
      updateVerification({ variables: values })
        .then((res) => {
          if (comment !== '') {
            try {
              createCommentForVerification(res.data.updateVerification.VerifyId);
              //<Snackbar message='Verification item updated!' visible={visible} setVisible={setVisible} autoDisappear />;
            } catch (err) {console.log('Error: /frontend/src/components/VerificationForms/EditVerificationForm//formik/updateVerification', err);
            }
          }

          //window.location.reload();
        })
        .catch((err) => {
          error = err;
        });
      if (error === '') {
        setVisible(true);
      }
      setTimeout(() => {
        window.location.href = `/inventory/editVerification/verifyId=${initialFormikValues.id}/${false}/${false}`;
      }, 2000);
      //refresh source grid
      localStorage.setItem('refresh', 'true');

      if (values.status === 'Transfer Approved' || values.status === 'Salvage Approved') {
        await createEOneUpdate({
          variables: {
            asset: {
              barcode: values.barCode,
              assetNumber: values.AssetNumber,
              department: values.itemDepartment,
              physicalOwner: values.physicalOwner,
              equipmentStatus: values.equipmentStatus,
            },
          },
        }).catch((err) => console.log('Error: /frontend/src/components/VerificationForms/EditVerificationForm//formik/createEOneUpdate', err));
      }

      e.preventDefault();
    },
  });

  const statusDropdownFunc = () => {
    if (props.toTransfer) {
      return <VerificationStatuses formik={formik} />;
    }

    return <StatusDropdown formik={formik} />;
  };

  return (
    <React.Fragment>
      <Form onSubmit={(e: any) => formik.handleSubmit(e)}>
        <div className='row'>
          <Button
            className='mt-3 ml-4'
            // onClick={() => window.history.back()}
            onClick={() => (window.location.href = '/inventory')}>
            Back
          </Button>

          <Button type='submit' variant='info' className='mt-3 ml-3 float-right'>
            Update Verification
          </Button>
        </div>
        <div className='row mt-3'>
          <div className='col-sm-6'>
            <div className='form-group form-inline'>
              <label className='col-sm-3'>ID</label>
              <input disabled={props.disableFields} id='id' name='id' className='form-control col-sm-8' value={formik.values.id} />
            </div>

            {statusDropdownFunc()}

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Bar Code</label>
              <input
                disabled={props.disableFields}
                id='barCode'
                name='barCode'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value={formik.values.barCode}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Verify Date</label>
              <input
                disabled={props.disableFields}
                id='verifyDate'
                name='verifyDate'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value={formik.values.verifyDate}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>User ID</label>
              <input
                disabled={props.disableFields}
                id='userId'
                name='userId'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value={props.queryData.verificationById.UserId}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Department of User</label>
              <input
                disabled={props.disableFields}
                id='userDepartment'
                name='userDepartment'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value={user.currentRole.department.Abbreviation}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Type</label>
              <input
                disabled={props.disableFields}
                id='type'
                name='type'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value={formik.values.type}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Serial #</label>
              <input
                disabled={props.disableFields}
                id='serialNumber'
                name='serialNumber'
                className='form-control col-sm-8'
                value={props.data.serialNumber}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Asset # (from EnterpriseOne)</label>
              <input
                disabled={props.disableFields}
                id='assetNumber'
                name='assetNumber'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value={props.queryData.verificationById.AssetNumber}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Department</label>
              <input disabled={props.disableFields} name='itemDepartment' className='form-control col-sm-8' value={formik.values.itemDepartment} />
            </div>

            <AdditionalTransferFields data={props.data} disableFields={props.disableFields} toTransfer={props.toTransfer} formik={formik} />

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Latitude</label>
              <input
                disabled={props.disableFields}
                id='latitude'
                name='latitude'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value={formik.values.latitude}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>Longitude</label>
              <input
                disabled={props.disableFields}
                id='longitude'
                name='longitude'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value={formik.values.longitude}
              />
            </div>

            <div className='form-group form-inline'>
              <label className='col-sm-3'>IP Address</label>
              <input
                disabled={props.disableFields}
                id='IpAddress'
                name='IpAddress'
                className='form-control col-sm-8'
                onChange={formik.handleChange}
                value=''
              />
            </div>
          </div>
          <div className='col-sm-6'>
            <label>Add Comment</label>
            <textarea className='form-control' id='comment' rows={3} value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
            <CommentsTimeline verifyId={props.queryData.verificationById.VerifyId} barCode={props.data.verificationById.BarCodeNumber} />
          </div>
        </div>
      </Form>
      <div>
        <Snackbar message='Verification item created!' visible={createVisible} setVisible={setCreateVisible} autoDisappear />
      </div>
      <div>
        <Snackbar message='Verification item updated!' visible={visible} setVisible={setVisible} autoDisappear />;
      </div>
    </React.Fragment>
  );
};

export default EditVerificationForm;
